(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ErrorPanel", [], factory);
	else if(typeof exports === 'object')
		exports["ErrorPanel"] = factory();
	else
		root["ErrorPanel"] = factory();
})(window, function() {
return 